import { ExternalEmployeeResponse } from "@/Common/Api/ExternalCommunications/Dto/Responses/ExternalEmployeeResponse";
import { Modal } from "@/Common/Components/Modals/Modal";
import { Popup } from "@/Common/Components/Modals/Popup";
import { IPatient } from "@/Common/Models/Patient/IPatient";
import { ExportableFileModel } from "@/ExportableFile/Models/ExportableFileTableItem";
import { BaseExternalMessageFormComponent, BaseExternalMessageFormState, IBaseExternalMessageFormProps } from "./BaseExternalMessageFormComponent";

interface IExternalMessageFormPopupProps extends IBaseExternalMessageFormProps {
    selectedExternalEmployee?: ExternalEmployeeResponse;
    selectedPatient?: IPatient;
    selectedAttachments?: ExportableFileModel[];
}

class ExternalMessageFormPopupComponent extends BaseExternalMessageFormComponent<IExternalMessageFormPopupProps, BaseExternalMessageFormState> {
    private id: string = "ExternalMessageFormPopupComponent";

    constructor(props: IExternalMessageFormPopupProps) {
        super(props);

        const initialState = BaseExternalMessageFormState.createDefault();
        initialState.selectedPatient = props.selectedPatient;
        initialState.recipients = props.selectedExternalEmployee ? [this.props.selectedExternalEmployee] : [];
        this.state = initialState;
    }

    public componentDidMount(): void {
        this.setOverlay(this.id);

        if (!isArrayNullOrUndefinedOrEmpty(this.props.selectedAttachments))
            this.handleOnFileAttached(this.props.selectedAttachments.map(x => x.Model));
    }

    public render(): JSX.Element {
        if (!this.state || !this.state.messageModel)
            return super.renderEmpty();

        return (
            <div>
                {this.renderAttachmentPreview(this.state.exportableFileToPreview, this.state.attachmentIdToPreview)}
                {this.renderUnattachableFilesWarning()}
                {this.renderFileSelection()}
                <Popup
                    width={1080}
                    topPosition={40}
                    leftPosition={300}
                    title={cacheStore.GetString("NewExternalCommunicationLabel")}
                    draggable={true}
                    onCloseDelegate={() => this.props.onClose && this.props.onClose()}
                >
                    {this.renderBody()}
                    {this.renderFooter()}
                </Popup>
            </div>
        );
    }

    protected renderBody(): JSX.Element {
        return (
            <div style={{ padding: "40px 0 20px 0", minHeight: "440px", maxHeight: "660px", overflow: "hidden overlay" }}>
                {super.renderBody()}
            </div>
        );
    }

    protected renderFooter(): JSX.Element {
        return (
            <div className="p-footer">
                {super.renderFooter()}
            </div>
        );
    }

    protected renderUnattachableFilesWarning(): JSX.Element {
        if (isArrayNullOrUndefinedOrEmpty(this.state.unattachableFiles))
            return null;

        return (
            <Modal
                title={cacheStore.GetString("ErrorLabel")}
                showOverlay={true}
                disableOverlayClose={true}
                footer={this.renderWarningModalFooter()}
                onClose={() => this.mutateState(s => s.unattachableFiles = [])}
            >
                <div>
                    <p>{cacheStore.GetString("Attach_UnsupportedFileTypes")}:</p>
                    <ul style={{ listStyle: "inherit", marginLeft: "20px" }}>
                        {this.state.unattachableFiles.map((x, i) => <li key={`error_${i}`} style={{ margin: "5px 0", listStyleType: "disc" }}>{x}</li>)}
                    </ul>
                </div>
            </Modal>
        );
    }

    private renderWarningModalFooter(): JSX.Element {
        return (
            <div className="flex-container" style={{ "justifyContent": "flex-end" }}>
                <div style={{ "marginLeft": "5px" }}>
                    <button
                        className="btn btn-primary"
                        onClick={() => this.mutateState(s => s.unattachableFiles = [])}
                    >
                        {cacheStore.GetString("OKLabel")}
                    </button>
                </div>
            </div>
        );
    }
}

export { ExternalMessageFormPopupComponent };
